/* Samago PDP — CTA sticky mobile.
   Muestra la barra fija inferior solo cuando el CTA principal quedó por encima
   del viewport (el usuario scrolleó más allá). Desktop: oculto por CSS. */
(function () {
  function normalizeText(value) {
    return (value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function collectSpecPairs() {
    var pairs = [];
    document.querySelectorAll('.samago-specs__row').forEach(function (row) {
      var label = normalizeText(row.querySelector('dt') && row.querySelector('dt').textContent);
      var value = normalizeText(row.querySelector('dd') && row.querySelector('dd').textContent);
      if (label && value) pairs.push({ label: label, value: value });
    });
    document.querySelectorAll('.samago-caract__cell:not(.samago-caract__cell--empty)').forEach(function (cell) {
      var label = normalizeText(cell.querySelector('.samago-caract__label') && cell.querySelector('.samago-caract__label').textContent);
      var value = normalizeText(cell.querySelector('.samago-caract__value') && cell.querySelector('.samago-caract__value').textContent);
      if (label && value) pairs.push({ label: label, value: value });
    });
    return pairs;
  }

  function initDescriptionDedupe() {
    var block = document.querySelector('[data-samago-description-block]');
    var body = document.querySelector('[data-samago-description-body]');
    if (!block || !body) return;

    var pairs = collectSpecPairs();
    if (!pairs.length) return;

    body.querySelectorAll('p, li').forEach(function (node) {
      var text = normalizeText(node.textContent);
      if (!text) return;

      var repeatsSpec = pairs.some(function (pair) {
        return text.indexOf(pair.label) !== -1 && text.indexOf(pair.value) !== -1;
      });

      if (repeatsSpec) node.remove();
    });

    body.querySelectorAll('ul, ol').forEach(function (list) {
      if (!normalizeText(list.textContent)) list.remove();
    });

    if (!normalizeText(body.textContent)) block.remove();
  }

  // Galería propia: imagen principal + thumbnails + flechas + contador.
  function initGallery() {
    document.querySelectorAll('[data-samago-gallery]').forEach(function (g) {
      var slides = Array.prototype.slice.call(g.querySelectorAll('[data-gallery-slide]'));
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-gallery-thumb]'));
      var current = g.querySelector('[data-gallery-current]');
      var thumbShell = g.querySelector('[data-gallery-thumbs-shell]');
      var thumbRail = g.querySelector('[data-gallery-thumbs]');
      var thumbPrev = g.querySelector('[data-gallery-thumbs-prev]');
      var thumbNext = g.querySelector('[data-gallery-thumbs-next]');
      var verticalThumbsQuery = window.matchMedia('(min-width: 990px)');
      var thumbnailControlsQuery = window.matchMedia('(min-width: 750px) and (max-width: 989px)');
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var total = slides.length;
      if (total < 2) return;
      var index = 0;
      var controlFrame = null;

      function scrollBehavior() {
        return reducedMotion.matches ? 'auto' : 'smooth';
      }

      function maxThumbScroll() {
        if (!thumbRail) return 0;
        return Math.max(0, thumbRail.scrollWidth - thumbRail.clientWidth);
      }

      function updateThumbControls() {
        controlFrame = null;
        if (!thumbRail || !thumbPrev || !thumbNext) return;
        var maxScroll = maxThumbScroll();
        var showControls = thumbnailControlsQuery.matches && maxScroll > 1;
        thumbPrev.hidden = !showControls;
        thumbNext.hidden = !showControls;
        thumbPrev.disabled = thumbRail.scrollLeft <= 1;
        thumbNext.disabled = thumbRail.scrollLeft >= maxScroll - 1;
        if (thumbShell) {
          thumbShell.classList.toggle('has-overflow', maxScroll > 1);
          thumbShell.classList.toggle('is-at-start', thumbRail.scrollLeft <= 1);
          thumbShell.classList.toggle('is-at-end', thumbRail.scrollLeft >= maxScroll - 1);
        }
      }

      function scheduleThumbControls() {
        if (controlFrame !== null) return;
        controlFrame = window.requestAnimationFrame(updateThumbControls);
      }

      function revealThumb(thumb) {
        if (!thumbRail || !thumb) return;
        var railRect = thumbRail.getBoundingClientRect();
        var thumbRect = thumb.getBoundingClientRect();
        var outsideRail = verticalThumbsQuery.matches
          ? thumbRect.top < railRect.top || thumbRect.bottom > railRect.bottom
          : thumbRect.left < railRect.left || thumbRect.right > railRect.right;
        if (outsideRail) {
          thumb.scrollIntoView({ behavior: scrollBehavior(), block: 'nearest', inline: 'nearest' });
        }
      }

      function show(i) {
        i = ((i % total) + total) % total;
        index = i;
        slides.forEach(function (slide, slideIndex) {
          slide.classList.toggle('is-active', slideIndex === i);
        });
        thumbs.forEach(function (thumb, thumbIndex) {
          var active = thumbIndex === i;
          thumb.classList.toggle('is-active', active);
          if (active) {
            thumb.setAttribute('aria-current', 'true');
            revealThumb(thumb);
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
        if (current) current.textContent = String(i + 1);
        scheduleThumbControls();
      }

      function thumbnailStep() {
        if (!thumbRail || !thumbs.length) return 0;
        var gap = parseFloat(window.getComputedStyle(thumbRail).columnGap) || 0;
        return thumbs[0].offsetWidth + gap;
      }

      function scrollThumbnails(direction) {
        if (!thumbRail) return;
        thumbRail.scrollBy({
          left: direction * thumbnailStep(),
          behavior: scrollBehavior(),
        });
      }

      thumbs.forEach(function (thumb, thumbIndex) {
        thumb.addEventListener('click', function () {
          show(thumbIndex);
        });
      });

      var prev = g.querySelector('[data-gallery-prev]');
      var next = g.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', function () { show(index - 1); });
      if (next) next.addEventListener('click', function () { show(index + 1); });
      if (thumbPrev) thumbPrev.addEventListener('click', function () { scrollThumbnails(-1); });
      if (thumbNext) thumbNext.addEventListener('click', function () { scrollThumbnails(1); });

      g.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') show(index - 1);
        else if (event.key === 'ArrowRight') show(index + 1);
      });

      if (thumbRail) thumbRail.addEventListener('scroll', scheduleThumbControls, { passive: true });
      window.addEventListener('resize', scheduleThumbControls);
      window.addEventListener('load', scheduleThumbControls, { once: true });
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(scheduleThumbControls);
      }
      if (thumbnailControlsQuery.addEventListener) {
        thumbnailControlsQuery.addEventListener('change', scheduleThumbControls);
      } else {
        thumbnailControlsQuery.addListener(scheduleThumbControls);
      }
      scheduleThumbControls();
    });
  }

  function init() {
    initDescriptionDedupe();
    initGallery();
    var sticky = document.querySelector('[data-samago-sticky-cta]');
    var anchor = document.querySelector('.samago-buybox__cta');
    if (!sticky || !anchor || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          if (scrolledPast) {
            sticky.removeAttribute('hidden');
          } else {
            sticky.setAttribute('hidden', '');
          }
        });
      },
      { threshold: 0 }
    );
    observer.observe(anchor);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
